import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowTemplate } from '@nimmsta/ng-commons-lib/models';
import { Dashboard, DashboardEditorTarget } from '../models/dashboard';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  protected http = inject(HttpClient);

  getDashboard(
    target: DashboardEditorTarget = { type: 'organization' },
  ): Observable<Dashboard> {
    if (target.type === 'workflowTemplate') {
      return this.http.get<Dashboard>(
        `${environment.apiUrls.workflow}/api/v1/workflow-template/${target.templateId}/dashboard`,
      );
    }
    return this.http.get<Dashboard>(
      `${environment.apiUrls.workflow}/api/v1/dashboard`,
    );
  }

  saveDashboard(
    dashboard: Dashboard,
    target: DashboardEditorTarget = { type: 'organization' },
  ): Observable<Dashboard> {
    if (target.type === 'workflowTemplate') {
      return this.http.put<Dashboard>(
        `${environment.apiUrls.workflow}/api/v1/workflow-template/${target.templateId}/dashboard`,
        { configuration: dashboard.configuration },
      );
    }
    return this.http.post<Dashboard>(
      `${environment.apiUrls.workflow}/api/v1/dashboard`,
      dashboard,
    );
  }

  getWorkflowTemplate(templateId: string): Observable<WorkflowTemplate> {
    return this.http.get<WorkflowTemplate>(
      `${environment.apiUrls.workflow}/api/v1/workflow-template/${templateId}`,
    );
  }

  getWorkflowTemplateDefinition(
    templateId: string,
  ): Observable<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(
      `${environment.apiUrls.workflow}/api/v1/workflow-template/${templateId}/definition`,
    );
  }
}
